import { Injectable } from "@angular/core";
import { BaseApi } from "./baseService";
import { Http, RequestOptions, URLSearchParams } from "@angular/http";
import { ConfigService } from "./configService";
import { Seller } from "../objects/amazon/seller";
import { AmazonStoreCredentials } from "../objects/amazon/AmazonStoreCredentials";
import { Cookie } from "ng2-cookies/ng2-cookies";
import { SearchResponse } from "../objects/responses/searchResponse";
import { BaseResponse } from "../objects/common/baseResponse";
import * as deepExtend from "deep-extend";
import { AmazonProduct } from "../objects/amazon/AmazonProduct";
import { CookieService } from "ng2-cookies";

declare var window: any;
window.Buffer = window.Buffer || class Buffer {
};


@Injectable()
export class AmazonService extends BaseApi {
    constructor(http: Http, configService: ConfigService, private cookieService: CookieService) {
        super(http, configService);
    }

    public seller: Seller = new Seller();

    public prevUrl: string = null;

    public userEmail: string;

    public exportProducts(sellerId: string, marketplaceId: string, mwsAuthToken: string, companyName: string): void {
        let params = new URLSearchParams();

        params.append('sellerId', sellerId.toString());
        params.append('marketplaceId', marketplaceId.toString());
        params.append('mwsAuthToken', mwsAuthToken.toString());
        params.append('companyName', companyName.toString());

        this.get(new RequestOptions({
            url: `amazon/export`,
            search: params
        }));
    }

    public exportAndSaveProducts(sellerId: string, storeId: string): Promise<BaseResponse<Seller>> {
        return this.get(new RequestOptions({
            url: `amazon/product/export/${sellerId}/${storeId}`
        }));
    }

    public exportStoreProducts(sellerId: string, storeId: string): Promise<Seller> {
        return this.exportAndSaveProducts(sellerId, storeId).then((response) => {
            deepExtend(this.seller, response.Data);
            return response.Data;
        })

    }

    public getCurrentSeller(): Promise<Seller> {
        if (this.seller.Id)
            return new Promise((resolve, reject) => resolve(this.seller));

        if (!Cookie.get(this.configService.config.UserAmazonCookieName))
            return null;

        const userId = +Cookie.get(this.configService.config.UserAmazonCookieName);

        return this.getSellerByUserId(userId).then(x => {
            deepExtend(this.seller, x.Data);
            return this.seller;

        })
    }

    public setCurrentSeller(obj: Seller): Promise<Seller> {
        if (obj == null) {
            this.cookieService.delete(this.configService.config.ApiTokenCookieName);
            this.cookieService.delete(this.configService.config.UserAmazonCookieName);
            return;
        }

        const userId = +Cookie.get(this.configService.config.UserAmazonCookieName);
        obj.UserId = userId;
        obj.Email = this.userEmail;

        return this.modifySeller(obj).then((response) => {
            deepExtend(this.seller, response.Data);
            return response.Data;
        });
    }

    public getSellers(skip: number, top: number): Promise<BaseResponse<SearchResponse<Seller>>> {
        let params = new URLSearchParams();

        params.append('skip', skip.toString());
        params.append('top', top.toString());

        return this.get(new RequestOptions({
            url: `amazon/seller`,
            search: params
        }));
    }

    public getSellerByUserId(id: number): Promise<BaseResponse<Seller>> {
        return this.get(new RequestOptions({
            url: `amazon/seller/${id}`
        }));
    }

    public modifySeller(seller: Seller): Promise<BaseResponse<Seller>> {
        return this.post(new RequestOptions({
            url: `amazon/seller/${seller.UserId}`,
            body: seller
        }));
    }

    public getProducts(sellerId: string,
                       storeId: string,
                       skip: number,
                       top: number,
                       isAdmin: boolean = false,
                       prop: string | null = null,
                       isAscending: boolean | null = null): Promise<BaseResponse<SearchResponse<AmazonProduct>>> {
        let params = new URLSearchParams();

        params.append('skip', skip.toString());
        params.append('top', top.toString());
        params.append('isAdmin', isAdmin.toString());

        if (prop != null && isAscending != null) {
            params.append('prop', prop);
            params.append('isascending', isAscending.toString())
        }

        return this.get(new RequestOptions({
            url: `amazon/${sellerId}/store/${storeId}/product`,
            search: params
        }))
    }

    public updateProduct(sellerId: string, storeId: string, product: AmazonProduct): Promise<BaseResponse<string>> {
        return this.put(new RequestOptions({
            url: `amazon/seller/${sellerId}/store/${storeId}/product`,
            body: product
        }))
    }

    public updateProducts(sellerId: string, storeId: string, products:  Array<AmazonProduct>): Promise<BaseResponse<string>> {
        return this.put(new RequestOptions({
            url: `amazon/seller/${sellerId}/store/${storeId}/products`,
            body: products
        }))
    }

    public setPrevUrl(url: string){
        this.prevUrl = url;
    }

    public getHelloSignUrl(seller: Seller){
        if(!seller.Email){
            seller.Email = this.userEmail;
        }
        return this.get(new RequestOptions({
            url: `sign?email=${seller.Email}&fullName=${seller.ContactName}`,
        }));
    }
}


// WEBPACK FOOTER //
// ./app/services/amazon.service.ts